module.exports = __webpack_public_path__ + "static/media/avatar31.f7f3b39c.png";